import { Component, Input } from '@angular/core';
import { EDIT_BOOKING_ITEM_DIALOG } from 'src/testIds';
import {
  AvailabilityResponse,
  Conflict
} from '../../shared/availability-response.model';
import { TestIdDirective } from '../../../shared/directives/test-id.directive';
import { NgSwitch, NgSwitchCase } from '@angular/common';

@Component({
  selector: 'app-booking-item-availability',
  templateUrl: './availability.component.html',
  standalone: true,
  imports: [NgSwitch, NgSwitchCase, TestIdDirective]
})
export class AvailabilityComponent {
  @Input() set availability(value: AvailabilityResponse[]) {
    if (!value) {
      return;
    }
    this.availabilities = value.map(
      ({ conflicts, ...availabilities }) => availabilities
    );
    this.conflicts = value.flatMap(({ conflicts }) => conflicts);
    this.updateMessageAndStatus();
  }

  @Input() set quantityRequested(value) {
    this.quantity = value ?? 1;
    this.updateMessageAndStatus();
  }

  private availabilities: Omit<AvailabilityResponse, 'conflicts'>[];
  private quantity = 0;
  testId = EDIT_BOOKING_ITEM_DIALOG.AVAILABILITY;
  conflicts: Conflict[] = [];

  status: 'OK' | 'WARN' | 'ERROR' = 'WARN';
  message = 'No availability information';

  private updateMessageAndStatus() {
    if (!this.quantity || !this.availabilities) {
      this.status = 'WARN';
      this.message = 'No availability information';
      return;
    }
    if (this.conflicts.length === 0) {
      if (this.isAnyUnderstock()) {
        this.status = 'ERROR';
        this.message = 'There is insufficient stock to service this hire';
        return;
      } else {
        this.status = 'OK';
        this.message = 'There are no conflicts with this booking';
        return;
      }
    }
    if (this.isAnyUnderstock()) {
      this.status = 'ERROR';
      this.message =
        'Conflicting hires and/or bookings: Insufficient stock to service this hire';
      return;
    }
    this.status = 'WARN';
    this.message =
      'There are conflicting hires and/or bookings, however there is currently enough stock to service this hire.';
  }

  private isAnyUnderstock() {
    if (!this.availabilities) {
      return;
    }
    const items = this.availabilities.map(({ item, product, category }) => ({
      item,
      product,
      category
    }));
    if (
      items.some(({ item, product, category }) => {
        if (item && item.available < item.allocated + this.quantity) {
          return true;
        }
        if (product && product.available < product.allocated + this.quantity) {
          return true;
        }
        if (
          category &&
          category.available < category.allocated + this.quantity
        ) {
          return true;
        }
        return false;
      })
    ) {
      return true;
    }
    return false;
  }
}
